module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABC0lEQVRIS6XUP0rFQBDH8e+QVGIwW3gTsdJK7Z6KIrnCnCjFFjmBCPrgRRDFK4mFhSSsLFg8Qv7sZrdePjvMzG+FladpmqLv+61zrlDVkyEja1yPdl3XAmfAk6o+JMMDdGeMua+q6jcJruv6MM/zV1+piLRlWd6Nof6R4FbEoMFwLBoEr0EXYY9mWdaKyPlST4OHl4JOVpyKTsLW2m+gAN6MMddTKzUXrtF1s9Z+AUfAJ7BR1Z/YhE7BByLy7Jy7Aj6Am1h8MiDW2n38HbiNwWeTl4IvRtrjwAtwCQRXvgj7oa3Bg+A1eDAci0fBe/gWuJjreTQ8gu9UdRP8CS0l7X8VH51zx6p6Orz/B8TalhejDXW3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/returns.png
// module id = Q+tX
// module chunks = 0